import { EstadoEnum, obtenerIdEstado, obtenerIdTipoEstudio, TipoEstudioEnum } from "@shared/enums";
import { ClienteDTO } from "./Cliente.DTO";
import { Nilable } from "@shared/utils";
import { IPanelPayloadDTO, PanelPayloadDTO } from "./PanelPayload.DTO";

export interface IPanelDTO {
    id: number;
    customer: number;
    brand: string;
    type: string;
    universe: string[];
    sample_size: number;
    research: Nilable<number>;
    last_run_datetime: string;
    created_by: Nilable<number>;
    created_at: string;
    payload: IPanelPayloadDTO;
    status: string;
    files: string[];
}

export class PanelDTO {
    public id = 0;
    public cliente = new ClienteDTO();
    public marca = "";
    public tipo = TipoEstudioEnum.BRAND_PENETRATION;
    public tags: string[] = [];
    public muestra = 0;
    public investigacion: Nilable<number>;
    public ultimaCorrida = new Date();
    public creadoPor: Nilable<number>;
    public fechaCreado = new Date();
    public payload = new PanelPayloadDTO();
    public estado = EstadoEnum.REQUESTED;
    public archivos: string[] = [];

    constructor(json: Nilable<Partial<IPanelDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IPanelDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.customer != null) {
            this.cliente = new ClienteDTO({ id: json.customer });
        }
        if (json.brand != null) {
            this.marca = json.brand;
        }
        if (json.type != null) {
            this.tipo = TipoEstudioEnum[json.type];
        }
        if (json.universe != null) {
            this.tags = json.universe;
        }
        if (json.sample_size != null) {
            this.muestra = json.sample_size;
        }
        if (json.research != null) {
            this.investigacion = json.research;
        }
        if (json.last_run_datetime != null) {
            this.ultimaCorrida = new Date(json.last_run_datetime);
        }
        if (json.created_by != null) {
            this.creadoPor = json.created_by;
        }
        if (json.created_at != null) {
            this.fechaCreado = new Date(json.created_at);
        }
        if (json.payload != null) {
            this.payload = new PanelPayloadDTO(json.payload);
        }
        if (json.status != null) {
            this.estado = EstadoEnum[json.status];
        }
        if (json.files != null) {
            this.archivos = json.files;
        }
    }

    public obtenerJSON(): IPanelDTO {
        return {
            id: this.id,
            customer: this.cliente.id,
            brand: this.marca,
            type: obtenerIdTipoEstudio(this.tipo),
            universe: this.tags,
            research: this.investigacion,
            sample_size: this.muestra,
            last_run_datetime: this.ultimaCorrida.toJSON(),
            created_by: this.creadoPor,
            created_at: this.fechaCreado.toJSON(),
            payload: this.payload.obtenerJSON(),
            status: obtenerIdEstado(this.estado),
            files: this.archivos
        };
    }

    public clone(): PanelDTO {
        return new PanelDTO(this.obtenerJSON());
    }
}
